// self returning method, as we want always asset path to end with /
export const getAssetPath = () => {
  const baseUrl = import.meta.env.BASE_URL;
  if (!baseUrl.endsWith('/')) return `${baseUrl}content/`;
  return `${baseUrl}content/`;
};

export const assetPath = getAssetPath();
export const imagePath = `${assetPath}images/`;
const charsPath = `${imagePath}chars/`;

export const assets = {
  common: {
    logo: `${imagePath}logo.webp`,
    diamond: `${imagePath}diamond.svg`,
    heroes: `${imagePath}heroes.webp`,
  },

  chars: {
    soother: `${charsPath}soother.webp`,
    chair: `${charsPath}chair.webp`,
    ecigaret: `${charsPath}ecigaret.webp`,
    lights: `${charsPath}lights.webp`,
    heater: `${charsPath}heater.webp`,
    slime: `${charsPath}slime.webp`,
    bike: `${charsPath}bike.webp`,
  },

  sounds: {
    introMusic: `${assetPath}sounds/intro_music.mp3`,
    outroMusic: `${assetPath}sounds/outro_music.mp3`,
  },

  game_lights: {
    // sounds
    sounds: {
      music: `${assetPath}game_lights/sounds/music.mp3`,
      click: `${assetPath}game_lights/sounds/click.mp3`,
      broken: `${assetPath}game_lights/sounds/broken.mp3`,
      fail: `${assetPath}game_lights/sounds/fail.mp3`,
      success: `${assetPath}game_lights/sounds/success.mp3`,
    },

    // assets
    star: `${assetPath}game_lights/images/star.svg`,
    bg: `${assetPath}backgrounds/bg_memory.webp`,
  },

  game_heater: {
    // sounds - using common sounds as the specific folder doesn't exist
    sounds: {
      music: `${assetPath}game_heater/sounds/music.mp3`,
      click: `${assetPath}game_heater/sounds/click.mp3`,
      success: `${assetPath}game_heater/sounds/success.mp3`,
      fail: `${assetPath}game_heater/sounds/fail.mp3`,
      burning: `${assetPath}game_heater/sounds/burning.mp3`,
      freezing: `${assetPath}game_heater/sounds/freezing.mp3`,
    },

    // images - now using WebP format
    images: {
      bg_normal: `${assetPath}game_heater/images/heater_bg_normal.webp`,
      bg_frozen: `${assetPath}game_heater/images/heater_bg_frozen.webp`,
      bg_frozen_max: `${assetPath}game_heater/images/heater_bg_frozen_max.webp`,
      bg_fire: `${assetPath}game_heater/images/heater_bg_fire.webp`,
      button_cold: `${assetPath}game_heater/images/button_cold.svg`,
      button_hot: `${assetPath}game_heater/images/button_hot.svg`,
      alert_icon: `${assetPath}game_heater/images/heater-alerted.svg`,
      heater_frozen: `${assetPath}game_heater/images/heater_frozen.webp`,
      heater_burned: `${assetPath}game_heater/images/heater_burned.webp`,
    },
  },

  game_quizz: {
    // sounds
    sounds: {
      music: `${assetPath}game_quizz/sounds/music.mp3`,
      success: `${assetPath}game_quizz/sounds/success.mp3`,
      wrong: `${assetPath}game_quizz/sounds/wrong.mp3`,
      chrono: `${assetPath}game_quizz/sounds/chrono.mp3`,
    },

    // images
    bg: `${assetPath}backgrounds/bg_labo.webp`,
  },
};
